import React from "react";
import { Button } from "..";
import { colors, css, fonts, glyphs} from "../../Styles";
import { ButtonTypes } from "../../Definitions";

interface FilterItem {
  type: string;
  items: string[];
  setItems: React.Dispatch<React.SetStateAction<string[]>>;
}

type filterDisplayListProps = {
  filterGroups: FilterItem[]
} 

export default function FilterDisplayList({ filterGroups }: filterDisplayListProps) {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "5px", height: "45px", maxWidth: "500px", alignItems: "end", marginBottom: "5px", boxSizing: "border-box" }}>
      {filterGroups.map(({ type, items, setItems }, index) => (
        <div key={index} style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
          {items.map((item, i) => (
            <div
              key={i}
              onClick={() => setItems(prev => prev.filter(i => i !== item))}
              style={{
                cursor: "pointer",
                backgroundColor: colors.greyPrimary,
                ...css.colorTag,
                ...fonts.header,
                ...fonts.fontSize4,
                color: colors.whitePrimary,
                display: "flex",
                gap: "5px",
                alignItems: "center"
              }}
            >
              {item}
              <glyphs.Close size="10px" fillColor={colors.whitePrimary} />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}


    // <div style={{ display: "flex", flexWrap: "wrap", gap: "5px", height: "45px", maxWidth: "500px", alignItems: "end", marginBottom: "5px", boxSizing: "border-box" }}>
    //   {selectedConditions.map((condition, index) => (<div key={index} onClick={() => setSelectedConditions(prev => prev.filter(con => con !== condition))} 
    //     style={{ cursor: "pointer", backgroundColor: colors.greyPrimary, ...css.colorTag, ...fonts.header, ...fonts.fontSize4, color: colors.whitePrimary, display: "flex", gap: "5px", alignItems: "center" }}>
    //       {condition}
    //       <glyphs.Close size="10px" fillColor={colors.whitePrimary}/>
    //   </div>))}
    //   {selectedLocations.map((location, index) => (<div key={index} onClick={() => setSelectedLocations(prev => prev.filter(loc => loc !== location))} 
    //     style={{ cursor: "pointer", backgroundColor: colors.greyPrimary, ...css.colorTag, ...fonts.header, ...fonts.fontSize4, color: colors.whitePrimary, display: "flex", gap: "5px", alignItems: "center" }}>
    //       {location}
    //       <glyphs.Close size="10px" fillColor={colors.whitePrimary}/>
    //   </div>))}
    //   {selectedMilestones.map((milestone, index) => (<div key={index} onClick={() => setSelectedMilestones(prev => prev.filter(mil => mil !== milestone))} 
    //     style={{ cursor: "pointer", backgroundColor: colors.greyPrimary, ...css.colorTag, ...fonts.header, ...fonts.fontSize4, color: colors.whitePrimary, display: "flex", gap: "5px", alignItems: "center" }}>
    //       {milestone}
    //       <glyphs.Close size="10px" fillColor={colors.whitePrimary}/>
    //   </div>))}
    // </div>
